import { Controller } from "@hotwired/stimulus"

// Keeps the narrow audiences (dispatch acknowledgement, contact import) as standalone
// credentials. Each one authorizes a single endpoint and nothing else, so it cannot be
// combined with another transport or with capability grants. The server enforces the same
// boundary; this controller prevents an invalid combination from being selected in the form.
const NARROW_AUDIENCES = ["dispatch_ack", "contact_import"]

export default class extends Controller {
  static targets = ["audience", "grant", "narrowNotice"]

  connect () {
    this.sync()
  }

  change (event) {
    const changed = event.currentTarget
    if (!changed.checked) {
      this.sync()
      return
    }

    if (NARROW_AUDIENCES.includes(changed.dataset.audience)) {
      this.audienceTargets.forEach((input) => {
        if (input !== changed) input.checked = false
      })
    } else {
      this.narrowInputs.forEach((input) => { input.checked = false })
    }

    this.sync()
  }

  sync () {
    const narrow = this.narrowInputs.some((input) => input.checked)
    this.narrowNoticeTarget.hidden = !narrow
    this.grantTargets.forEach((grant) => {
      grant.hidden = narrow
      grant.querySelectorAll("input").forEach((input) => {
        input.disabled = narrow
      })
    })
  }

  get narrowInputs () {
    return this.audienceTargets.filter((input) => NARROW_AUDIENCES.includes(input.dataset.audience))
  }
}
